import React from 'react';

//Header format [ { label, key, style, format }, ... ]
//Data columns will be matched to header key

const ReportTable = ({headers, data}) =>
  <div className='report-table'>
    <div className='row'>
      <div className='col-sm-12'>
        <table>
          <thead>
            <tr>
              { headers.map((header, i) =>
                <th style={header.style} key={i}>{header.label}</th>
             ) }
            </tr>
          </thead>
          <tbody>
            { data.map((row, j) =>
              <tr key={j}>
                { headers.map((col, k) =>
                  <td style={col.style} key={k}>
                    {
                      col.linkFunction ?
                        <a href={col.linkFunction(row)}>{col.format ? col.format(row[col.key]) : row[col.key]}</a> :
                        <span>{col.format ? col.format(row[col.key]) : row[col.key]}</span>
                    }
                    {  }
                  </td>
                ) }
              </tr>
            ) }
          </tbody>
        </table>
      </div>
    </div>
  </div>

;

export default ReportTable;
